module.exports = __webpack_public_path__ + "img/ctrl-swap-1.57821a8c.svg";